import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/charger-dc-icon.svg'
import _imports_1 from '@/assets/images/charger-ac-icon.svg'
import _imports_2 from '@/assets/images/charger-power.svg'
import _imports_3 from '@/assets/images/info-circle-pricing.svg'
import _imports_4 from '@/assets/images/info-circle-charging.svg'


const _hoisted_1 = { class: "charging-layout" }
const _hoisted_2 = { class: "charging__main" }
const _hoisted_3 = { class: "charging__card charging__card--location" }
const _hoisted_4 = { class: "charging__card charging__card--type" }
const _hoisted_5 = { class: "charging-card__letter" }
const _hoisted_6 = { class: "charging-card__type" }
const _hoisted_7 = { class: "charging-card__info charger__info" }
const _hoisted_8 = {
  key: 0,
  class: "charger__info-icon",
  src: _imports_0,
  alt: ""
}
const _hoisted_9 = {
  key: 1,
  class: "charger__info-icon",
  src: _imports_1,
  alt: ""
}
const _hoisted_10 = { class: "charger__info-text" }
const _hoisted_11 = { class: "charging-card__power charger__power" }
const _hoisted_12 = { class: "charger__power-text" }
const _hoisted_13 = { class: "charging-card__price" }
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "charging-time" }
const _hoisted_16 = { class: "charging__card charging__card--time" }
const _hoisted_17 = {
  key: 0,
  class: "charging__card charging__card--time"
}
const _hoisted_18 = { class: "charging__card charging__card--progress" }
const _hoisted_19 = { class: "charging__card--text" }
const _hoisted_20 = { class: "charging-info" }
const _hoisted_21 = {
  key: 0,
  class: "charging-stop"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["PageHeader"]),
    _createElementVNode("main", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createElementVNode("p", null, _toDisplayString($props.selectedCharger.connector?.evseId), 1),
          _createElementVNode("p", null, _toDisplayString($props.selectedCharger.address), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", _hoisted_5, _toDisplayString($props.selectedCharger.connector?.label), 1),
        _createElementVNode("div", null, [
          _createElementVNode("p", _hoisted_6, _toDisplayString($setup.connectorTypeName), 1),
          _createElementVNode("div", _hoisted_7, [
            ($props.selectedCharger.connector?.mode === 'DC')
              ? (_openBlock(), _createElementBlock("img", _hoisted_8))
              : (_openBlock(), _createElementBlock("img", _hoisted_9)),
            _createElementVNode("span", _hoisted_10, _toDisplayString($setup.price) + " | " + _toDisplayString($props.selectedCharger.connector?.voltage) + " V | " + _toDisplayString($props.selectedCharger.connector?.current) + " A", 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _cache[1] || (_cache[1] = _createElementVNode("img", {
              class: "charger__power-icon",
              src: _imports_2,
              alt: ""
            }, null, -1)),
            _createElementVNode("span", _hoisted_12, _toDisplayString($props.selectedCharger.connector?.power
                  ? $props.selectedCharger.connector.power / 1000
                  : "N/a") + " kW", 1)
          ]),
          _createElementVNode("p", _hoisted_13, [
            _createTextVNode(_toDisplayString($setup.price) + " ", 1),
            _cache[2] || (_cache[2] = _createElementVNode("img", {
              class: "charging-card__price-icon",
              src: _imports_3,
              alt: ""
            }, null, -1))
          ])
        ]),
        _createElementVNode("img", {
          src: `${$setup.config.imagesPath}/charger-${$setup.connectorTypeSlug}.svg`,
          alt: "",
          class: "charging-card__connector-type-icon"
        }, null, 8, _hoisted_14)
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("chargingPage.chargingLayout.chargingStarted")), 1),
          _createElementVNode("p", null, _toDisplayString($setup.displayTime($props.chargingStartedAt)), 1)
        ]),
        ($setup.endTime)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$t("chargingPage.chargingLayout.chargingFinished")), 1),
              _createElementVNode("p", null, _toDisplayString($setup.displayTime($setup.endTime)), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.$t("chargingPage.chargingLayout.subTitle")), 1)
      ]),
      _createElementVNode("div", _hoisted_20, [
        _cache[3] || (_cache[3] = _createElementVNode("img", {
          src: _imports_4,
          alt: "",
          class: "charging-info__icon"
        }, null, -1)),
        _createElementVNode("p", null, _toDisplayString(_ctx.$t($setup.chargingInfo)), 1)
      ])
    ]),
    ($setup.stopButtonVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          _createVNode($setup["ButtonComponent"], {
            block: "",
            loading: $setup.submitIsLoading,
            primary: "",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.stopClick()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("chargingPage.chargingLayout.stopButton")), 1)
            ]),
            _: 1
          }, 8, ["loading"])
        ]))
      : _createCommentVNode("", true),
    ($setup.isConfirmModalActive)
      ? (_openBlock(), _createBlock($setup["ConfirmModal"], {
          key: 1,
          "yes-button-color-class": "btn-primary",
          "main-title": _ctx.$t('chargingPage.confirm.stopCharging.mainTitle'),
          "sub-title": _ctx.$t('chargingPage.confirm.stopCharging.subTitle'),
          "yes-title": _ctx.$t('chargingPage.confirm.stopCharging.yesTitle'),
          "no-title": _ctx.$t('chargingPage.confirm.stopCharging.noTitle'),
          onConfirm: $setup.confirmStopCharge,
          onCancel: $setup.handleConfirmModalCancel
        }, null, 8, ["main-title", "sub-title", "yes-title", "no-title"]))
      : _createCommentVNode("", true),
    ($setup.isFeedbackModalActive)
      ? (_openBlock(), _createBlock($setup["FeedbackModal"], {
          key: 2,
          "main-title": _ctx.$t($setup.feedbackStopMainTitle),
          "sub-title": _ctx.$t($setup.feedbackStopSubTitle),
          success: $setup.feedbackStopSuccess,
          onConfirm: $setup.handleFeedbackModalOkClick
        }, null, 8, ["main-title", "sub-title", "success"]))
      : _createCommentVNode("", true)
  ]))
}